import React from "react";
import styles from "./AlertMessage.module.css";
import { AlertCircle, AlertTriangle, CheckCircle, Info } from "lucide-react";
import type { alertMessageProps, alertType } from "./types.props";

const ICONS: Record<alertType, React.ReactNode> = {
    info: <Info size={24} />,
    success: <CheckCircle size={24} />,
    warning: <AlertTriangle size={24} />,
    error: <AlertCircle size={24} />,
};

const AlertMessage = ({
    type = "info",
    title,
    children,
    className = "",
    ...rest
}: alertMessageProps) => {
    if (!children) {
        return null;
    }

    const icon = ICONS[type];

    return (
        <div
            className={`${styles["message-container"]} ${styles[`type-${type}`]} ${className}`}
            role={type === "error" ? "alert" : "status"}
            aria-live={type === "error" ? "assertive" : "polite"}
            {...rest}
        >
            <div className={styles["message-icon"]} aria-hidden="true">
                {icon}
            </div>
            <div className={styles["message-content"]}>
                {title && <h3 className={styles["message-title"]}>{title}</h3>}
                {children}
            </div>
        </div>
    );
};

export default AlertMessage;
